import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import TextEditorButton from '../text-editor-button';

export default function createInlineStyleButton({ inlineStyle, content: Content, tooltipText }) {
  return class InlineStyleButton extends Component {
    static propTypes = {
      hasInlineStyle: PropTypes.func.isRequired,
      setInlineStyle: PropTypes.func.isRequired,
      className: PropTypes.string,
    };

    isActive = () => this.props.hasInlineStyle(inlineStyle);
    handleClick = () => this.props.setInlineStyle(inlineStyle);

    render() {
      const {
        hasInlineStyle, // eslint-disable-line no-unused-vars
        setInlineStyle, // eslint-disable-line no-unused-vars
        className,
        ...buttonProps
      } = this.props;
      return (
        <TextEditorButton
          className={classNames(className, `text-editor__${inlineStyle.toLowerCase()}-button`)}
          onClick={this.handleClick}
          isActive={this.isActive()}
          icon={Content}
          tooltipText={tooltipText}
          {...buttonProps}
        />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/create-inline-style-button.js